import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* Offset do rail fixo (64px) no padrao responsivo; <=720px full-width. */
  width: calc(100vw - 64px);
  min-height: calc(100vh - 40px);
  margin: 15px 0 25px 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--cco-pad);
  box-sizing: border-box;

  @media (max-width: 720px) {
    width: 100vw;
    margin: 15px 0 25px 0;
  }
`;

export const Title = styled.h1`
  font-size: var(--fs-heading);
  font-weight: bold;
  text-align: center;
  color: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.darkerblue
      : props.theme.colors.label};
`;
